import React from "react";
import { Play } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import Reveal from "./Reveal";

// Foto & video asli momen perjalanan customer CEO Travel.
const MOMENTS = [
  {
    key: "city-tour",
    img: "/batam-city-tour.jpeg",
    label: { id: "City Tour", en: "City Tour", zh: "市区游览" },
    span: "lg:col-span-2",
  },
  {
    key: "gokart-adventure",
    img: "/batam-gokart-adventure.jpeg",
    label: { id: "Adventure Trip", en: "Adventure Trip", zh: "冒险之旅" },
  },
  {
    key: "family-trip",
    img: "/batam-family-trip.jpeg",
    label: { id: "Family Trip", en: "Family Trip", zh: "家庭旅行" },
  },
  {
    key: "besties-trip",
    img: "/batam-besties-trip.jpeg",
    label: { id: "Trip Bersama Sahabat", en: "Besties Trip", zh: "闺蜜旅行" },
  },
  {
    key: "family-trip-2",
    img: "/batam-family-trip2.jpeg",
    label: { id: "Family Trip", en: "Family Trip", zh: "家庭旅行" },
  },
  {
    key: "coffee-factory",
    img: "/coffie-factory-trip.Jpeg",
    label: { id: "Coffee Factory Tour", en: "Coffee Factory Tour", zh: "咖啡工厂之旅" },
  },
  {
    key: "family-video",
    video: "/family-trip.mp4",
    label: { id: "Family Trip", en: "Family Trip", zh: "家庭旅行" },
    span: "lg:col-span-2",
  },
  {
    key: "family-video-2",
    video: "/family-trip2.mp4",
    label: { id: "Family Trip", en: "Family Trip", zh: "家庭旅行" },
    span: "lg:col-span-2",
  },
];

const pick = (obj, lang) => obj[lang] || obj.id || "";

export const TravelMoments = () => {
  const { lang } = useLang();

  const titles = {
    id: { eyebrow: "Galeri", title: "Momen Perjalanan.", sub: "Diabadikan oleh peserta trip kami." },
    en: { eyebrow: "Gallery", title: "Travel Moments.", sub: "Captured by our valued participants." },
    zh: { eyebrow: "画廊", title: "旅行时刻。", sub: "由我们的贵宾旅客拍摄。" },
  };
  const T = titles[lang] || titles.en;

  return (
    <section
      id="moments"
      data-testid="moments-section"
      className="bg-[#FBFAF6] py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="grid items-end gap-8 md:grid-cols-12 md:gap-12">
          <Reveal className="md:col-span-7">
            <span className="flex items-center gap-3 text-[11px] uppercase tracking-[0.28em] text-[#0E9A57]">
              <span className="h-px w-8 bg-[#0E9A57]" />
              {T.eyebrow}
            </span>
            <h2 className="mt-5 font-[Fraunces] text-4xl font-medium leading-[1.05] tracking-tight text-[#0C2230] sm:text-5xl">
              {T.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-5">
            <p className="text-base leading-relaxed text-[#0C2230]/70 md:text-lg">
              {T.sub}
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2">
          {MOMENTS.map((m, idx) => (
            <Reveal
              key={m.key}
              delay={idx * 0.06}
              className={`col-span-1 ${m.span || ""}`}
            >
              <article
                data-testid={`moment-card-${idx}`}
                className="group relative aspect-[16/9] overflow-hidden rounded-3xl ring-1 ring-[#0C2230]/10 shadow-[0_10px_30px_-14px_rgba(12,34,48,0.3)] transition-shadow duration-500 hover:shadow-[0_18px_44px_-16px_rgba(12,34,48,0.45)]"
              >
                {m.video ? (
                  <video
                    src={m.video}
                    muted
                    loop
                    playsInline
                    autoPlay
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                  />
                ) : (
                  <img
                    src={m.img}
                    alt={pick(m.label, lang)}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0C2230]/80 via-[#0C2230]/10 to-transparent" />
                {m.video && (
                  <span className="absolute right-4 top-4 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/90 shadow-md">
                    <Play className="h-4 w-4 fill-[#0C2230] text-[#0C2230]" />
                  </span>
                )}
                <span className="absolute bottom-4 left-4 rounded-full bg-white/95 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-[#0C2230] shadow-md">
                  {pick(m.label, lang)}
                </span>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TravelMoments;
